import styled from 'styled-components';
export const IngredientBg = styled.div.withConfig({
  displayName: "Ingredientstyle__IngredientBg",
  componentId: "sc-1o40ie9-0"
})(["", " @media (max-width:", "){", "}"], {
  "width": "100%",
  "borderRadius": "60px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(253 243 236 / var(--tw-bg-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))"
});
export const IngredientContainer = styled.div.withConfig({
  displayName: "Ingredientstyle__IngredientContainer",
  componentId: "sc-1o40ie9-1"
})(["", " box-shadow:0px 0px 0px 0px rgba(0,0,0,0.05),0px 1px 3px 0px rgba(0,0,0,0.05),0px 5px 5px 0px rgba(0,0,0,0.04),0px 11px 7px 0px rgba(0,0,0,0.03),0px 20px 8px 0px rgba(0,0,0,0.01),0px 31px 9px 0px rgba(0,0,0,0.00);max-width:750px;@media (max-width:", "){", "}"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "marginTop": "3.5rem",
  "marginBottom": "3.5rem",
  "width": "100%",
  "borderRadius": "32px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "padding": "1.5rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "0px",
  "marginBottom": "0px",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0px",
  "paddingBottom": "0px",
  "--tw-shadow": "0 0 #0000",
  "--tw-shadow-colored": "0 0 #0000",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});
export const TitleWrapper = styled.div.withConfig({
  displayName: "Ingredientstyle__TitleWrapper",
  componentId: "sc-1o40ie9-2"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "1rem"
});
export const Title = styled.h2.withConfig({
  displayName: "Ingredientstyle__Title",
  componentId: "sc-1o40ie9-3"
})(["", " @media (max-width:", "){", "}"], {
  "margin": "0px",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(206 14 45 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "28px"
});
export const SubTitle = styled.span.withConfig({
  displayName: "Ingredientstyle__SubTitle",
  componentId: "sc-1o40ie9-4"
})(["", " @media (max-width:", "){", "}"], {
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(232 144 158 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem"
});
export const IngredientContent = styled.div.withConfig({
  displayName: "Ingredientstyle__IngredientContent",
  componentId: "sc-1o40ie9-5"
})(["", " grid-template-columns:", ";.image{", "}@media (max-width:", "){", "}"], {
  "display": "grid",
  "gap": "1rem"
}, ({
  $isHasImage
}) => $isHasImage ? '300px auto' : 'auto', {
  "aspectRatio": "1 / 1",
  "width": "100%",
  "overflow": "hidden",
  "borderRadius": "1rem",
  "objectFit": "cover"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))"
});
export const IngredientList = styled.div.withConfig({
  displayName: "Ingredientstyle__IngredientList",
  componentId: "sc-1o40ie9-6"
})(["", ""], {
  "width": "100%",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
});
export const IngredientDetail = styled.div.withConfig({
  displayName: "Ingredientstyle__IngredientDetail",
  componentId: "sc-1o40ie9-7"
})(["", " background-color:", ";.name-wrapper{:after{", " background-image:url('/images/cp-logo.png');display:inline-block;content:'';}&:hover{", "}}.unit{", "}"], {
  "display": "flex",
  "justifyContent": "space-between",
  "gap": "1rem",
  "borderRadius": "0.5rem",
  "padding": "0.5rem"
}, ({
  $shouldRenderBgColor
}) => $shouldRenderBgColor ? 'rgba(235, 235, 235, 0.24)' : '#FFF', {
  "marginLeft": "0.25rem",
  "height": "1.5rem",
  "width": "1.5rem",
  "--tw-translate-y": "0.25rem",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "backgroundSize": "contain"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
}, {
  "textAlign": "right"
});